import { $ } from '@zeus/index'
import { typedGql } from '@zeus/typedDocumentNode'
import { scalars } from '~/gql/utils/scalars'

const reminderSettingsFields = {
  id: true,
  enabled: true,
  firstDelayDays: true,
  frequencyDays: true,
  maxReminders: true,
  sendHour: true,
  subject: true,
  body: true,
  completionDigestEnabled: true,
  convocationEnabled: true,
} as const

export const GQL_REMINDER_SETTINGS = typedGql('query', { scalars })({
  reminderSettings: reminderSettingsFields,
})

export const GQL_UPDATE_REMINDER_SETTINGS = typedGql('mutation', { scalars })({
  updateReminderSettings: [
    { input: $('input', 'UpdateReminderSettingsInput!') },
    reminderSettingsFields,
  ],
})

export const GQL_SEND_REMINDER_TEST = typedGql('mutation', { scalars })({
  sendReminderTest: [
    { input: $('input', 'UpdateReminderSettingsInput') },
    { sent: true, to: true },
  ],
})
